import type * as React from 'react'

import { cn } from '@/lib/cn'

interface ITagProps extends React.HTMLAttributes<HTMLDivElement> {
  color?: string
  text: string
  labelClassName?: string
}

export const Tag: React.FC<ITagProps> = ({
  color = 'bg-gray-200',
  text,
  labelClassName,
  className,
  ...props
}) => {
  return (
    <div
      className={cn(
        'py-1 px-3 gap-2.5 rounded text-system-neutral-white font-inter font-semibold leading-5 text-sm inline-flex items-center max-w-full',
        color,
        className,
      )}
      {...props}
    >
      <span className={cn('max-w-full', labelClassName)}>{text}</span>
    </div>
  )
}
